import { AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ck-content',
  templateUrl: './ck-content.component.html',
  styleUrls: ['./ck-content.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CkContentComponent implements OnInit, AfterViewInit {

  @Input() content;
  lightboxSrc: string | null = null;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {
  }

  ngOnInit() {}

  ngAfterViewInit() {
    const container = this.el.nativeElement.querySelector('.ck__content');
    this.renderer.listen(container, 'click', (event: Event) => {
      const target = event.target as HTMLElement;

      if (target.tagName.toLowerCase() === 'img') {
        const src = (target as HTMLImageElement).src;

        // podíváme se na parent
        const parent = target.parentElement;
        if (!!target.hasAttribute('data-thumb') || (parent && !!parent.getAttribute('data-thumb'))) {
          this.openLightbox(src);
        }
      }
    });
  }

  openLightbox(src: string) {
    this.lightboxSrc = src;
  }

  closeLightbox() {
    this.lightboxSrc = null;
  }
}
